import { Directive, ElementRef, HostListener, Input } from '@angular/core';

@Directive({
	selector: '[numericInput]'
})
export class NumericInputDirective {

	constructor(private el: ElementRef) { }

	@HostListener('keydown', ['$event']) onKeyDown(event: Event) {
		let e = <KeyboardEvent>event;
		
		if ([46, 8, 9, 27, 13, 110, 190].indexOf(e.keyCode) !== -1 ||
			(e.keyCode === 65 && (e.ctrlKey || e.metaKey)) ||		// Ctrl+A
			(e.keyCode === 67 && (e.ctrlKey || e.metaKey)) ||		// Ctrl+C
			(e.keyCode === 86 && (e.ctrlKey || e.metaKey)) ||		// Ctrl+V
			(e.keyCode === 88 && (e.ctrlKey || e.metaKey)) ||		// Ctrl+X
			(e.keyCode >= 35 && e.keyCode <= 39)) {					// home, fin, izquierda, derecha
			
			return;
		}

		if ((e.shiftKey || (e.keyCode < 48 || e.keyCode > 57)) && (e.keyCode < 96 || e.keyCode > 105)) {
			e.preventDefault();
		}
	}
}
